<template>
  <div class="flex-1 p-4 grid grid-cols-1 gap-y-3 gap-x-4 sm:grid-cols-6 self-start" style="min-width: 500px;">
    <InputGroupLabel
      name="categoryTitle"
      caption="変更処理（解約・変更）"
      class="mt-4"
    />

    <!-- 種別 -->
    <div class="sm:col-span-full">
      <SelectionButton2
        name="employmentClass"
        :caption="items['classification']"
        v-model="rp.classification"
        :disabled="referenceMode2"
        :item="classList"
        :multiSelect="false"
        :required="true"
        :error="!requireValidateArr('classification').result"
        :errorMessage="requireValidateArr('classification').message"
        @change="changeClassification()"
      />
    </div>

    <!-- 変更日・解約日 -->
    <div v-if="className(rp.classification)" class="sm:col-span-full">
      <WmsDateInput
        name="changeDate"
        :caption="className(rp.classification)=='解約'?'解約日':items['changeDate']"
        v-model="rp.changeDate"
        :disabled="referenceMode2"
        :clearable="true"
        :required="isRequired('changeDate')"
        :error="!requireValidateStr('changeDate').result"
        :errorMessage="requireValidateStr('changeDate').message"
        @change="setTitle()"
      />
    </div>

    <!-- 物件名 -->
    <div v-if="className(rp.classification)" class="sm:col-span-full">
      <WmsSuggestInput
        name="buildingName"
        :caption="items['buildingName']"
        v-model="rp.buildingName"
        :disabled="referenceMode2"
        :required="true"
        :displayField="['site1', 'site2', 'agreementFlg']"
        :selectionItems="buildingListByClient"
        :error="!requireValidateStr('buildingName').result"
        :errorMessage="requireValidateStr('buildingName').message"
        @selected="siteSelected($event)"
        @change="siteChange()"
      >
      </WmsSuggestInput>
    </div>

    <!-- 物件コード -->
    <div v-if="rp.siteCode" class="sm:col-span-full text-blue-700 font-bold text-sm">
      物件コード：{{ rp.siteCode }}
    </div>

    <div v-if="rp.siteCode" class="sm:col-span-full text-sm text-gray-700 border border-blue-700 rounded px-2 pt-1 pb-2 mt-5">
      <div class="text-blue-600 text-xs font-bold flex">ビルメンツ情報
        <PrimaryButton text="再取得" size="xs" class="ml-auto" @click="getBillingData()"></PrimaryButton>
      </div>

      <!-- 物件名 -->
      <div class="ml-3 font-bold text-xs text-gray-700" v-if="rp.sn">{{ rp.sn }}</div>
      <!-- 得意先名 -->
      <div class="ml-3 font-bold text-xs text-gray-700" v-if="rp.cc">{{ rp.cn1 }} {{ rp.cn2 }} （得意先コード： {{ rp.cc }}）</div>

      <div class="table border-collapse mt-5">
        <div class="table-row">
          <div class="table-cell p-2 font-bold text-gray-500">予定送付日</div>
          <div class="table-cell p-2" :class="rp.sentDate=='20'?'':'text-red-700 font-bold'">{{ rp.sentDate }}</div>
        </div>
        <div class="table-row">
          <div class="table-cell p-2 font-bold text-gray-500">締め日</div>
          <div class="table-cell p-2" :class="rp.closingDate=='月末'?'':'text-red-700 font-bold'">{{ rp.closingDate }}</div>
        </div>
        <div class="table-row">
          <div class="table-cell p-2 font-bold text-gray-500">請求送付日</div>
          <div class="table-cell p-2" :class="rp.billingDate=='月末'?'':'text-red-700 font-bold'">{{ rp.billingDate }}</div>
        </div>
        <div class="table-row">
          <div class="table-cell p-2 font-bold text-gray-500">請求宛先名</div>
          <div v-if="rp.sentNames&&rp.sentNames.length" class="table-cell p-2">
            <span v-if="rp.sentNames.length>1" class="text-red-700">（{{ rp.sentNames.length }}種類あります）</span>
            {{ rp.sentNames.join(' 、 ') }}
          </div>

        </div>
      </div>
    </div>

    <!-- 得意先変更 -->
    <div v-if="rp.classification=='1'" class="sm:col-span-full mt-5 flex" :class="rp.changeClient?'font-bold text-gray-700':'text-gray-600'">
      <div class="self-center cursor-pointer whitespace-nowrap">
        <input type="checkbox" id="client" v-model="rp.changeClient" @change="changeCheckCode" :disabled="referenceMode">
        <label for="client" class="p-2" :class="rp.changeClient?'text-indigo-700':''">得意先 変更</label>
      </div>
      <div class="text-xs ml-3 whitespace-nowrap">
        <div class="mb-2">変更前</div>
        <div class="font-normal">{{ rp.clientName }}</div>
        <div class="mt-1 font-normal">（得意先コード：{{ rp.clientCode }}）</div>
      </div>
      <div class="self-center mx-2">⇒</div>
      <div class="w-full">
        <WmsSuggestInput
          v-if="rp.changeClient&&!referenceMode"
          caption="変更後"
          id="client-name"
          name="clientName2"
          :selectionItems="clientLists"
          :displayField="['clientName', 'clientDepartmentName']"
          v-model="rp.clientName2"
          :required="rp.changeClient"
          class="min-w-300px w-full"
          @selected="clientSelected"
          @change="clientNameChanged"
        >
        </WmsSuggestInput>
        <div v-else class="text-xs">
          <div class="mb-2">変更後</div>
          <div>{{ rp.clientName2 }}</div>
        </div>
        <div v-if="rp.changeClient" class="text-xs mt-1">（得意先コード：{{ rp.clientCode2 }}）</div>
      </div>
    </div>

    <!-- 物件コード変更 -->
    <div v-if="rp.classification=='1'" class="sm:col-span-full mt-5 flex" :class="rp.changeCdSite?'font-bold text-gray-700':'text-gray-600'">
      <div class="self-center cursor-pointer">
        <input type="checkbox" id="cdSite" v-model="rp.changeCdSite" @change="changeCheckCode" :disabled="referenceMode2">
        <label for="cdSite" class="p-2" :class="rp.changeCdSite?'text-indigo-700':''">物件コード 変更</label>
      </div>
      <div class="ml-3">
        <div class="text-xs mb-2">変更前</div>
        <div class="font-normal">{{ rp.siteCode }}</div>
      </div>
      <div class="self-center mx-2">⇒</div>
      <div>
        <div class="text-xs mb-0.5">変更後（分かる場合はご記入ください）</div>
        <NumericTextInput2
          name="cdSite2"
          v-model="rp.cdSite2"
          :format="false"
          :disabled="!rp.changeCdSite||referenceMode2"
        />
      </div>
    </div>

    <!-- すべて解約 -->
    <div v-else-if="rp.classification=='2'" class="sm:col-span-full mt-5">
      <input type="checkbox" id="allend" v-model="rp.allEnd" :disabled="referenceMode2" @change="allEndCheck">
      <label for="allend" class="p-2" :class="rp.allEnd?'text-indigo-700 font-bold':'text-gray-700'">全ての契約を解約</label>
    </div>

    <!-- 契約中ビルメンツデータ -->
    <div class="sm:col-span-full mt-5">
      <div class="flex justify-between border-b border-gray-400 w-full">
        <div class="font-bold text-sm w-fit mt-auto text-gray-700">契約中 ビルメンツデータ<span v-if="rp.contractList" class="pl-3">{{ rp.contractList.length }}件</span></div>
        <!-- 再取得ボタン -->
        <div class="flex mb-1">
          <NumericTextInput2
            name="year"
            v-model="rp.year"
            :format="false"
            :disabled="referenceMode2"
            class="w-24"
          />
          <div class="self-center text-xs font-bold text-gray-700 ml-1">年度のビルメンツデータ</div>
          <PrimaryButton v-if="!referenceMode2" text="再取得" size="xs" class="bg-green-500 ml-5" @click="siteSelected({ siteCode: rp.siteCode })"></PrimaryButton>
        </div>
      </div>
    </div>

    <!-- ローディング -->
    <div v-if="loading" class="sm:col-span-full text-gray-700 font-bold animate-pulse">
      契約情報取得中...
    </div>

    <!-- 契約リスト -->
    <div v-if="rp.contractList&&rp.contractList.length" class="sm:col-span-full mt-2">
      <div class="text-sm font-bold text-gray-700 mb-2">※{{ className(rp.classification) }}する契約にチェックを入れてください</div>
      <div>
        <table class="w-full border border-gray-300 text-xs ">
          <thead class="bg-colu">
            <tr class="text-gray-600">
              <th scope="col" class="text-center text-blue-700 cursor-pointer">
                <div v-if="!referenceMode" @click="allCheck(true)" class="mb-2">全選択</div>
                <div v-if="!referenceMode" @click="allCheck(false)">全解除</div>
              </th>
              <th scope="col" class="text-left px-2">作業内容区分<br>作業内容<br>（発注先）</th>
              <th scope="col" class="">3月</th>
              <th scope="col" class="">4月</th>
              <th scope="col" class="">5月</th>
              <th scope="col" class="">6月</th>
              <th scope="col" class="">7月</th>
              <th scope="col" class="">8月</th>
              <th scope="col" class="">9月</th>
              <th scope="col" class="">10月</th>
              <th scope="col" class="">11月</th>
              <th scope="col" class="">12月</th>
              <th scope="col" class="">1月</th>
              <th scope="col" class="">2月</th>
              <th scope="col" class="px-2">総額</th>
              <th scope="col" class="px-2">契約日<br>解約日</th>
            </tr>
          </thead>
          <tbody v-for="(row, i) in rp.contractList" :key="i" :class="setColor(row, i)" class="cursor-pointer">
            <tr @click="changeCheck(row)">
              <td scope="row" rowspan="2" class="text-center">
                <input
                  type="checkbox"
                  class="h-4 w-4 rounded p-2"
                  :disabled="true"
                  v-model="row.check"
                />
              </td>
              <td class="p-2">
                <div class="font-bold">{{ row.nameKubunWorkContent }}</div>
                <div class="my-1 text-yellow-800 font-bold">{{ row.nameWorkContent }}</div>
                <div>（{{ row.purchase }}）</div>
              </td>
              <td class="text-center ">{{ row.work3 }}</td>
              <td class="text-center ">{{ row.work4 }}</td>
              <td class="text-center ">{{ row.work5 }}</td>
              <td class="text-center ">{{ row.work6 }}</td>
              <td class="text-center ">{{ row.work7 }}</td>
              <td class="text-center ">{{ row.work8 }}</td>
              <td class="text-center ">{{ row.work9 }}</td>
              <td class="text-center ">{{ row.work10 }}</td>
              <td class="text-center ">{{ row.work11 }}</td>
              <td class="text-center ">{{ row.work12 }}</td>
              <td class="text-center ">{{ row.work1 }}</td>
              <td class="text-center ">{{ row.work2 }}</td>
              <td class="text-center px-2">{{ row.totalFee }}</td>
              <td class="text-center px-2">
                <div>{{ row.dateAgreement }}</div>
                <div class="mt-1" :class="row.dateCancellation?'text-red-700 font-bold':''">{{ row.dateCancellation || '-' }}</div>
              </td>
            </tr>
            <tr>
              <td colspan="15">
                <div class="mr-1">
                  <textarea
                    placeholder="備考"
                    v-model="row.memo"
                    :rows="2"
                    :disabled="referenceMode"
                    class="border-gray-400 text-sm text-gray-700 rounded w-full"
                    style="field-sizing: content;"
                  ></textarea>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 契約詳細情報 -->
    <div class="sm:col-span-full mt-7 border-b border-gray-400">
      <div class="font-bold text-sm w-fit mt-auto text-gray-700">契約中 契約詳細情報データ<span v-if="rp.detailList" class="pl-3">{{ rp.detailList.length }}件</span></div>
    </div>

    <!-- スタッフ情報 -->
    <div v-if="rp.staffList && rp.staffList.length" class="sm:col-span-full text-xs text-gray-700">
      <div class="font-bold">担当清掃員</div>
      <div class="border border-gray-300 rounded bg-blue-50">
        <div v-for="(staff, i) in rp.staffList" :key="'staff'+i" class="flex p-2">
          <div>● 契約コード（{{ staff.cdContract }}）</div>
          <div class="ml-2 font-bold">{{ staff.nameStaff }}</div>
          <div class="ml-2">（{{ staff.staffDailyCleaning }}）</div>
        </div>
      </div>
    </div>

    <!-- 変更箇所 -->
    <div v-if="rp.classification=='1'&&rp.detailList&&rp.detailList&&changePoint(rp.detailList)" class="sm:col-span-full mt-2 text-xs text-gray-700">
      <div class="font-bold text-yellow-700">変更箇所</div>
      <div class="flex flex-wrap bg-yellow-50">
        <div v-for="(key, i) in Object.keys(changePoint(rp.detailList))" :key="'ch'+i" class="p-2">
          <div class="mb-2 font-bold">{{ key }}</div>
          <div v-if="!changePoint(rp.detailList)[key]||!changePoint(rp.detailList)[key].length" class="text-gray-600 text-xss">---</div>
          <div v-for="(row, j) in changePoint(rp.detailList)[key]" :key="'de'+j">
            <div>● {{ row }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 契約詳細情報 -->
    <div v-if="rp.detailList" class="sm:col-span-full mt-2">
      <!-- 変更 -->
      <div v-if="rp.classification=='1'">
        <div v-for="(row, i) in rp.detailList" :key="'det'+i" class="border border-gray-300 rounded mb-5">
          <div class="text-white bg-blue-700 p-2 rounded-t font-bold">契約コード（{{ row.cdContract }}）<span class="pl-5">作業内容： {{ row.contentsWork }}</span></div>
          <div v-if="row.endDateContract" class="text-red-700 text-sm pl-3 my-1">※解約日が入っています（{{ (row.endDateContract) }}）</div>

          <div class="flex w-full p-2">
            <!-- 元データ -->
            <div class="w-full">
              <!-- 契約コード -->
              <!-- <div>
                <WmsTextInput
                  caption="契約コード"
                  v-model="row.cdContract"
                  :disabled="true"
                />
              </div> -->

              <!-- 契約日 -->
              <!-- <div>
                <WmsDateInput
                  name="startDateContract"
                  caption="契約日"
                  v-model="row.startDateContract"
                  :disabled="true"
                />
              </div> -->

              <!-- 作業内容 -->
              <!-- <div>
                <div class="text-xs text-gray-700 font-bold mb-0.5">作業内容</div>
                <select
                  v-model="row.cdContentsWork"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded bg-gray-200 cursor-not-allowed"
                  :disabled="true"
                >
                  <option
                    v-for="list in cdContentsWork"
                    :key='list.code'
                    :value="list.code"
                  >
                    {{ list.text }}
                  </option>
                </select>
              </div> -->

              <!-- エリア -->
              <!-- <div>
                <div class="text-xs text-gray-700 font-bold mb-0.5">営業所</div>
                <select
                  v-model="row.cdSalesOffice"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded bg-gray-200 cursor-not-allowed"
                  :disabled="true"
                >
                  <option
                    v-for="list in areaSelections"
                    :key='list.code'
                    :value="list.code"
                  >
                    {{ list.name }}
                  </option>
                </select>
              </div> -->

              <!-- 曜日ごとの勤務 -->
              <div v-for="(w, wi) in weeks" :key="w">
                <hr class="hr-week">
                <!-- 勤務形態 -->
                <div :class="!referenceMode2?'mt-34px':''">
                  <div class="text-xs text-gray-700 font-bold mb-0.5">{{ items['attendance' + w] }}</div>
                  <select
                    class="w-full rounded border-gray-300 text-sm bg-gray-200 cursor-not-allowed text-gray-800"
                    v-model="row['attendance' + w]"
                    :disabled="true"
                  >
                    <option v-for="at in attendanceTypes"
                      :key="'at'+at.value"
                      :value="at.value"
                    >
                      {{ at.text }}
                    </option>
                  </select>
                </div>

                <!-- 時間 -->
                <div>
                  <div class="text-xs text-gray-700 font-bold mb-0.5">{{ weekNames[wi] }} 勤務時間</div>
                  <div class="flex">
                    <WmsTimeInput2
                      v-model="row['start' + w]"
                      class=""
                      :clearable="true"
                      :hourItems="hourItems"
                      :minuteItems="minuteItems"
                      :disabled="true"
                    />
                    <div class="self-center mx-1 font-bold">～</div>
                    <WmsTimeInput2
                      v-model="row['end' + w]"
                      :clearable="true"
                      :hourItems="hourItems"
                      :minuteItems="minuteItems"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- 実働時間 -->
                <div>
                  <NumericTextInput2
                    :caption="items['workingHours' + w]"
                    v-model="row['workingHours' + w]"
                    :format="false"
                    :disabled="true"
                  />
                </div>
              </div>

              <hr class="hr-week">

              <!-- ゴミ搬出 -->
              <div>
                <div class="text-xs text-gray-700 font-bold mb-0.5">ゴミ搬出</div>
                <select
                  v-model="row.hasCarryingoutGarbageContract"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded bg-gray-200 cursor-not-allowed"
                  :disabled="true"
                >
                  <option
                    v-for="list in yesNo" :key="'tra'+list.value"
                    :value="list.value"
                  >
                    {{ list.text }}
                  </option>
                </select>
              </div>

              <!-- 祝日勤務 -->
              <div>
                <div class="text-xs text-gray-700 font-bold mb-0.5">祝日勤務</div>
                <select
                  v-model="row.kubunHolidayContract"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded bg-gray-200 cursor-not-allowed"
                  :disabled="true"
                >
                  <option v-for="list in holidayList" :value="String(list.code)" :key="'holi'+list.code">
                    {{ list.value }}
                  </option>
                </select>
              </div>

              <!-- 全社祝日出勤 -->
              <div>
                <div class="text-xs text-gray-700 font-bold mb-0.5">全社祝日出勤</div>
                <select
                  v-model="row.hasExportingCompanysHolidayContract"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded bg-gray-200 cursor-not-allowed"
                  :disabled="true"
                >
                  <option
                    v-for="list in yesNo" :key="'com'+list.value"
                    :value="list.value"
                  >
                    {{ list.text }}
                  </option>
                </select>
              </div>
            </div>

            <div class="w-fit mx-2 my-auto font-bold">⇒</div>

            <!-- ここから変更データ -->
            <div class="w-full">
              <!-- 契約コード -->
              <!-- <div>
                <div class="text-xs font-bold text-gray-700">契約コード<span class="text-red-700">※01 のようにゼロ埋めで入力</span></div>
                <WmsTextInput
                  v-model="row.cdContract2"
                  :class="bgColor(row, 'cdContract')"
                  :disabled="referenceMode2"
                  @change="changeValue(row, 'cdContract')"
                />
              </div> -->

              <!-- 契約日 -->
              <!-- <div>
                <WmsDateInput
                  name="startDateContract2"
                  caption="契約日"
                  v-model="row.startDateContract2"
                  :class="referenceMode2?'':bgColor(row, 'startDateContract')"
                  :disabled="referenceMode2"
                  @change="changeValue(row, 'startDateContract')"
                />
              </div> -->

              <!-- 作業内容 -->
              <!-- <div>
                <div class="text-xs text-gray-700 font-bold mb-0.5">作業内容</div>
                <select
                  v-model="row.cdContentsWork2"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded"
                  :class="selectBgColor(bgColor(row, 'cdContentsWork'))"
                  :disabled="referenceMode2"
                  @change="changeValue(row, 'cdContentsWork')"
                >
                  <option
                    v-for="list in workSelections" :key='list.code'
                    :value="list.code"
                  >
                    {{ list.text }}
                  </option>
                </select>
              </div> -->

              <!-- エリア -->
              <!-- <div>
                <div class="text-xs text-gray-700 font-bold mb-0.5">営業所</div>
                <select
                  v-model="row.cdSalesOffice2"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded"
                  :class="selectBgColor(bgColor(row, 'cdSalesOffice'))"
                  :disabled="referenceMode2"
                  @change="changeValue(row, 'cdSalesOffice')"
                >
                  <option
                    v-for="list in areaSelections" :key='list.code'
                    :value="list.code"
                  >
                    {{ list.name }}
                  </option>
                </select>
              </div> -->

              <!-- 曜日ごとの勤務 -->
              <div v-for="(w, wi) in weeks" :key="w">
                <hr class="hr-week">
                <!-- コピペ -->
                <div v-if="!referenceMode2" class="flex justify-end">
                  <div @click="copyPaste(row, w + '2', true)" class="py-1 px-3 bg-blue-100 text-blue-700 font-bold cursor-pointer text-xs">コピー</div>
                  <div @click="copyPaste(row, w + '2', false)" class="py-1 px-3 bg-green-100 text-green-700 font-bold cursor-pointer text-xs ml-5">ペースト</div>
                </div>
                <!-- 勤務形態 -->
                <div>
                  <div class="text-xs text-gray-700 font-bold mb-0.5">{{ items['attendance' + w] }}</div>
                  <select
                    class="w-full rounded border-gray-300 text-sm"
                    v-model="row['attendance' + w + '2']"
                    :disabled="referenceMode2"
                    :class="selectBgColor(bgColor(row, 'attendance' + w))"
                    @change="changeValue(row, 'attendance' + w)"
                  >
                    <option v-for="at in attendanceTypes" :value="at.value" :key="'at'+at.value">
                      {{ at.text }}
                    </option>
                  </select>
                </div>

                <!-- 時間 -->
                <div>
                  <div class="text-xs text-gray-700 font-bold mb-0.5">{{ weekNames[wi] }} 勤務時間</div>
                  <div class="flex">
                    <WmsTimeInput2
                      v-model="row['start' + w + '2']"
                      :class="bgColor(row, 'start' + w)"
                      :clearable="true"
                      :hourItems="hourItems"
                      :minuteItems="minuteItems"
                      :disabled="referenceMode2"
                      @change="changeValue(row, 'start' + w)"
                      @blur="blurTime(row, 'start' + w)"
                    />
                    <div class="self-center mx-1 font-bold">～</div>
                    <WmsTimeInput2
                      v-model="row['end' + w + '2']"
                      :class="bgColor(row, 'end' + w)"
                      :clearable="true"
                      :hourItems="hourItems"
                      :minuteItems="minuteItems"
                      :disabled="referenceMode2"
                      @change="changeValue(row, 'end' + w)"
                      @blur="blurTime(row, 'end' + w)"
                    />
                  </div>
                </div>

                <!-- 実働時間 -->
                <div>
                  <NumericTextInput2
                    :caption="items['workingHours' + w]"
                    v-model="row['workingHours' + w + '2']"
                    :format="false"
                    :class="bgColor(row, 'workingHours' + w)"
                    :disabled="referenceMode2"
                    @change="changeValue(row, 'workingHours' + w)"
                  />
                </div>
              </div>

              <hr class="hr-week">

              <!-- ゴミ搬出 -->
              <div>
                <div class="text-xs text-gray-700 font-bold mb-0.5">ゴミ搬出</div>
                <select
                  v-model="row.hasCarryingoutGarbageContract2"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded"
                  :class="selectBgColor(bgColor(row, 'hasCarryingoutGarbageContract'))"
                  :disabled="referenceMode2"
                  @change="changeValue(row, 'hasCarryingoutGarbageContract')"
                >
                  <option
                    v-for="list in yesNo" :key="'tra'+list.value"
                    :value="list.value"
                  >
                    {{ list.text }}
                  </option>
                </select>
              </div>

              <!-- 祝日勤務 -->
              <div>
                <div class="text-xs text-gray-700 font-bold mb-0.5">祝日勤務</div>
                <select
                  v-model="row.kubunHolidayContract2"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded"
                  :class="selectBgColor(bgColor(row, 'kubunHolidayContract'))"
                  :disabled="referenceMode2"
                  @change="changeValue(row, 'kubunHolidayContract')"
                >
                  <option v-for="list in holidayList" :value="String(list.code)" :key="'holi'+list.code">
                    {{ list.value }}
                  </option>
                </select>
              </div>

              <!-- 全社祝日出勤 -->
              <div>
                <div class="text-xs text-gray-700 font-bold mb-0.5">全社祝日出勤</div>
                <select
                  v-model="row.hasExportingCompanysHolidayContract2"
                  class="focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 w-full text-sm rounded"
                  :class="selectBgColor(bgColor(row, 'hasExportingCompanysHolidayContract'))"
                  :disabled="referenceMode2"
                  @change="changeValue(row, 'hasExportingCompanysHolidayContract')"
                >
                  <option
                    v-for="list in yesNo" :key="'com'+list.value"
                    :value="list.value"
                  >
                    {{ list.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 解約 -->
      <div v-else-if="rp.classification=='2'">
        <div v-for="(row, i) in rp.detailList" :key="'det'+i" class="border border-gray-300 rounded mb-5 p-2">
          <div class="w-full" @click="changeCheck(row)">
            <input type="checkbox" :id="'detai'+i" v-model="row.check" :disabled="true">
            <label :for="'detai'+i" class="p-2" :class="row.check?'text-indigo-700 font-bold':'text-gray-700'">契約コード {{ row.cdContract }} 解約</label>
          </div>

          <details class="mt-1 p-2 rounded border border-blue-300 bg-blue-50">
            <summary class="mb-2 text-xs font-bold text-blue-700 w-full">契約内容を表示</summary>
            <div class="flex text-xs px-2">
              <div class="table">
                <div class="table-row p-2">
                  <div class="table-cell">作業内容</div>
                  <div class="table-cell">： {{ getName(workSelections, row.cdContentsWork, 'code', 'text') }}</div>
                </div>
                <div class="table-row p-2">
                  <div class="table-cell">ゴミ搬出</div>
                  <div class="table-cell">： {{ getName(yesNo, row.hasCarryingoutGarbageContract, 'value', 'text') }}</div>
                </div>
                <div class="table-row p-2">
                  <div class="table-cell">祝日勤務</div>
                  <div class="table-cell">： {{ getName(holidayList, row.kubunHolidayContract, 'code', 'value') }}</div>
                </div>
                <div class="table-row p-2">
                  <div class="table-cell">全社祝日出勤</div>
                  <div class="table-cell">： {{ getName(yesNo, row.hasExportingCompanysHolidayContract, 'value', 'text') }}</div>
                </div>
              </div>

              <div class="table ml-6">
                <div v-for="(w, j) in weeks" :key="w" class="table-row">
                  <div class="table-cell">{{ weekNames[j] }}</div>
                  <div class="table-cell">： {{ row['start' + w] }}</div>
                  <div class="table-cell px-1"> - </div>
                  <div class="table-cell">{{ row['end' + w] }}</div>
                  <div class="table-cell">（{{ row['workingHours' + w] }}）</div>
                  <div class="table-cell">{{ getName(attendanceTypes, row['attendance' + w], 'value', 'text') }}</div>
                </div>
              </div>
            </div>
          </details>

        </div>
      </div>
    </div>
    <div class="text-transparent">{{reload}}</div>
  </div>
</template>

<script>
  import PrimaryButton from '@components/PrimaryButton.vue'
  import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
  import * as backend from '@libs/backend'
  import NumericTextInput2 from '@components/NumericTextInput2.vue'
  import SelectionButton2 from '@components/SelectionButton2.vue'
  import WmsTimeInput2 from '@wmscomponents/WmsTimeInput2.vue'
  import InputGroupLabel from './InputGroupLabel.vue'
  import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
  import * as moment from 'moment'
  import * as constants from '@libs/constants'
  import * as utils from '@libs/utils'
  import * as dialogs from '@libs/dialogs'

  const items = {
    classification: '種別',
    buildingName: '物件名',
    changeDate: '変更日（適用開始日）',
  }

  // 必須項目
  const require = [
    'classification',
    'buildingName',
    'changeDate'
  ]

  export default {
    components: {
      PrimaryButton,
      WmsDateInput,
      InputGroupLabel,
      NumericTextInput2,
      SelectionButton2,
      WmsTimeInput2,
      WmsSuggestInput,
    },

    props: {
      rp: {
        type: Object,
        default: () => {}
      },
      referenceMode: {
        type: Boolean,
        default: false
      },
      // 参照モードもしくはAKBS登録済み
      referenceMode2: {
        type: Boolean,
        default: false
      },
      // 得意先に紐づく物件リスト
      buildingListByClient: {
        type: Array,
      },
      // 得意先リスト
      clientLists: {
        type: Array,
      },
    },

    data() {
      return {
        loading: false,
        reload: 0,
        // プロパティと項目名
        items: items,
        // 曜日
        weeks: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        weekNames: ['月曜', '火曜', '水曜', '木曜', '金曜', '土曜', '日曜'],
        // 種別リスト
        classList: [{ value: '1', text: '変更' }, { value: '2', text: '解約' }],
        // 作業内容
        workSelections: constants.WORK_SELECTIONS,
        // エリア
        areaSelections: constants.AREA_LIST,
        // 勤務形態
        attendanceTypes: constants.ATTENDANCE_TYPES,
        // ゴミ
        yesNo: constants.YES_NO_CODE,
        // 祝日
        holidayList: constants.HOLIDAY_LIST,
        // 時間
        hourItems: constants.HOURS2,
        minuteItems: constants.MINUTES2,
        // コピー
        copy: {}
      }
    },

    computed: {
      /**
       * 種別名
       */
      className() {
        return (e) => {
          if (e && e.length) {
            const res = this.classList.find((c) => {
              return c.value == e[0]
            })
            if (res && res.text) {
              return res.text
            }
          }
          return ''
        }
      },

      /**
       * 契約詳細情報で変更があるところ
       */
      changePoint() {
        return (list) => {
          let res = null
          for (let i = 0; i < list.length; i++) {
            const l = list[i]
            const keys = Object.keys(this.items)
            for (let j = 0; j < keys.length; j++) {
              const key = keys[j] + 'BgColor'
              if (!res) {
                res = {}
              }
              if (!res['契約コード（' + l.cdContract + '）']) {
                res['契約コード（' + l.cdContract + '）'] = []
              }

              // 変更あり
              if (l[key]) {
                // 項目名を取得
                res['契約コード（' + l.cdContract + '）'].push(items[key.replace('BgColor', '')])
              }
            }
          }
          return res
        }
      },

      /**
       * 必須項目入力チェック（文字列）
       */
      requireValidateStr() {
        return (item) => {
          let name = items[item]
          if (item == 'changeDate') {
            if (this.className(this.rp.classification) == '解約') {
              name = '解約日'
            }
          }
          if (this.isRequired(item)) {
            if (!this.rp[item]) {
              return {
                result: false,
                message: `${name}は必須項目です。${name}を入力してください。`
              }
            }
          }

          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 必須項目入力チェック（配列）
       */
      requireValidateArr() {
        return (item)=> {
          const name = items[item]
          if (this.isRequired(item)) {
            if (!this.rp[item] || !this.rp[item].length) {
              return {
                result: false,
                message: `${name}は必須項目です。${name}を選択してください。`
              }
            }
          }

          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 必須判定
       */
      isRequired() {
        return (item) => {
          if (require.includes(item)) {
            return true
          }
          return false
        }
      }
    },

    async created() {
      if (this.rp) {
        // 年度をセット
        if (!this.rp.year) {
          this.rp.year = moment().add(-2, 'months').format('YYYY')
        }

        // プロパティと項目名セット
        for (let i = 0; i < this.weeks.length; i++) {
          const w = this.weeks[i]
          const n = this.weekNames[i]
          this.items['attendance' + w] = n + ' 勤務形態'
          this.items['start' + w] = n + ' 勤務（開始）時間'
          this.items['end' + w] = n + ' 勤務（終了）時間'
          this.items['workingHours' + w] = n + ' 実働時間'
        }
        this.items['hasCarryingoutGarbageContract'] = 'ゴミ搬出'
        this.items['kubunHolidayContract'] = '祝日勤務'
        this.items['hasExportingCompanysHolidayContract'] = '全社祝日出勤'
      }
    },

    methods: {
      /**
       * 種別変更
       */
      changeClassification() {
        this.rp.allEnd = false
        if (this.rp.siteCode) {
          this.siteSelected({ siteCode: this.rp.siteCode })
        }
        this.setTitle()
      },

      /**
       * 物件選択
       */
      async siteSelected(e) {
        this.rp.contractList = []
        this.rp.detailList = []
        this.rp.staffList = []
        this.rp.siteCode = e.siteCode
        this.rp.site1 = ''
        this.rp.site2 = ''

        // 契約台帳そのままの表示を別に保存
        if (e.site1) {
          this.rp.site1 = e.site1
          this.rp.site2 = e.site2
          this.rp.buildingName = (e.site1 || '')
          if (e.site2) {
            this.rp.buildingName = (e.site1 || '') + ' ' + e.site2
          }
        }

        if (e.siteCode) {
          this.loading = true
          const res = await backend.searchData('akbsTable/getContract', { siteCode: e.siteCode, year: this.rp.year, isCD: true })
          // ビルメンツデータ
          if (res.data.data && res.data.data.contract && res.data.data.contract.length) {
            if (!e.site1) {
              // 契約台帳そのままの表示を別に保存
              const con = res.data.data.contract[0]
              this.rp.site1 = con.nameSite1
              this.rp.site2 = con.nameSite2
              this.rp.buildingName = (con.nameSite1 || '')
              if (con.nameSite2) {
                this.rp.buildingName = (con.nameSite1 || '') + ' ' + con.nameSite2
              }
            }
            this.rp.contractList = res.data.data.contract
          }
          // 契約詳細情報データ
          if (res.data.data && res.data.data.detail && res.data.data.detail.length) {
            // 変更の場合
            if (this.rp.classification[0] == '1') {
              const list = []

              for (let i = 0; i < res.data.data.detail.length; i++) {
                const l = res.data.data.detail[i]
                const row = utils.clone(l)
                for (let j = 0; j < Object.keys(l).length; j++) {
                  const key = Object.keys(l)[j]
                  row[key + '2'] = l[key]
                }
                // 作業内容名取得
                row.contentsWork = ''
                const cw = this.workSelections.find((w) => {
                  return w.code == row.cdContentsWork
                })
                if (cw && cw.text) {
                  row.contentsWork = cw.text
                }
                list.push(row)
              }
              this.rp.detailList = list

            // 解約
            } else {
              this.rp.detailList = res.data.data.detail
            }
          }
          // 清掃員情報データ
          if (res.data.data && res.data.data.staff && res.data.data.staff.length) {
            this.rp.staffList = res.data.data.staff
          }

          this.getBillingData()
        }

        // 得意先データ
        if (e.clientCode) {
          // 選択したお客様情報を表示
          this.rp.clientName = e.client1 + ' ' + e.client2
          // リクエストポストのデータにお客様コードを追加
          this.rp.clientCode = e.clientCode
          // 住所を取得
          const cl = this.clientLists.find((c) => {
            return e.clientCode == c.clientCode
          })
          if (cl && cl.clientCode) {
            // 住所
            this.rp.clientAddress1 = cl.address1
            this.rp.clientAddress2 = cl.address2
          }
        }
        this.setTitle()
        this.loading = false
      },

      /**
       * 物件名変更
       */
      siteChange() {
        if (!this.rp.buildingName) {
          this.rp.contractList = []
          this.rp.detailList = []
          this.rp.staffList = []
          this.rp.siteCode = ''
          this.setTitle()
        }
      },

      /**
       * 得意先選択
       */
      clientSelected(e) {
        // 選択したお客様情報を表示
        this.rp.clientName2 = e.clientName + ' ' + e.clientDepartmentName

        // リクエストポストのデータにお客様コードを追加
        this.rp.clientCode2 = e.clientCode
        this.reload++
      },

      /**
       * 得意先変更
       */
      clientNameChanged() {
        if (!this.rp.clientName2) {
          this.rp.clientCode2 = null
        }
      },

      /**
       * 得意先変更もしくは物件コード変更チェックＢＯＸ
       */
      async changeCheckCode() {
        await utils.wait(100)
        if (!this.rp.changeClient) {
          this.rp.clientName2 = ''
          this.rp.clientCode2 = ''
        }

        if (!this.rp.changeCdSite) {
          this.rp.cdSite2 = ''
        }
      },

      /**
       * 全選択OR解除
       */
      allCheck(val) {
        this.rp.contractList.forEach(c => {
          c.check = val
        })
        this.reload++
      },

      /**
       * チェック
       */
      changeCheck(row) {
        if (this.referenceMode2) {
          return
        }
        // 解約で全契約解除の場合
        if (this.rp.classification=='2' && this.rp.allEnd && row.check) {
          const log = window.confirm('「全ての契約を解約」をOFFにしますか？')
          if (log) {
            this.rp.allEnd = false
          } else {
            return
          }
        }
        row.check = !row.check
        this.reload++
      },

      /**
       * 変更ある場合の背景色
       */
      bgColor(row, tar) {
        if (row[tar + 'BgColor']) {
          return 'i-bg-yellow-200'
        }
        return ''
      },

      /**
       * selectタグ用の背景色
       * @param val 黄色か空
       */
      selectBgColor(val) {
        let res = val
        if (this.referenceMode2) {
          let cur = ' cursor-not-allowed'
          if (!res) {
            res = 'bg-gray-200'
          }
          res += cur
        }
        return res
      },

      /**
       * 値の変更
       * @param row 対象契約データ
       * @param tar 対象プロパティ
       */
      changeValue(row, tar) {
        if (row[tar] != row[tar + '2']) {
          row[tar + 'BgColor'] = true
          if (tar.indexOf('workingHours') > -1) {
            if (Number(row[tar]) == Number(row[tar + '2'])) {
              row[tar + 'BgColor'] = false
            }
          }
        } else {
          row[tar + 'BgColor'] = false
        }
        this.reload++
      },

      /**
       * 勤務時間の変更
       * @param row 対象契約データ
       * @param tar 対象プロパティ
       */
      blurTime(row, tar) {
        if ((tar.indexOf('start') > -1 || tar.indexOf('end') > -1) && row[tar + 'BgColor']) {
          let start
          let end
          let wh
          if (tar.indexOf('start') > -1) {
            start = tar + '2'
            end = start.replace('start', 'end')
            wh = start.replace('start', 'workingHours')
          } else {
            end = tar + '2'
            start = end.replace('end', 'start')
            wh = end.replace('end', 'workingHours')
          }
          // 開始・終了時間から何時間になるかを取得
          const h = utils.getHours(row[start], row[end])
          row[wh] = String(h)
          this.changeValue(row, wh.replace('2', ''))
          this.reload++
        }
      },

      /**
       * 背景色設定
       * @param row 対象契約データ
       * @param tar 対象プロパティ
       */
      setColor(row, i) {
        if (row.check) {
          return 'bg-yellow-200 border-b-2 border-white'
        }
        if (i % 2 != 0) {
          return 'bg-blue'
        } else {
          return ''
        }
      },

      /**
       * 契約全て解約
       */
      async allEndCheck() {
        await utils.wait(100)
        if (this.rp.allEnd) {
          if (this.rp.contractList && this.rp.contractList.length) {
            this.rp.contractList.forEach((c) => {
              c.check = true
            })
          }
          if (this.rp.detailList && this.rp.detailList.length) {
            this.rp.detailList.forEach((c) => {
              c.check = true
            })
          }
          this.reload++
        }
      },

      /**
       * キーに対する項目名を取得
       * @param list 対象リスト
       * @param tar 対象キー
       * @param key キーとなるプロパティ名
       * @param val 値となるプロパティ名
       */
      getName(list, tar, key, val) {
        const res = list.find((l) => {
          return tar == String(l[key])
        })

        if (res && res[key]) {
          return res[val]
        }
        return ''
      },

      /**
       * タイトル設定
       */
      setTitle() {
        let day = ''
        if (this.rp.changeDate) {
          day = moment(this.rp.changeDate + ' 00:00:00').format('YYYY年M月D日')
        }
        this.rp.inquiry_title = `【${day + ' ' + this.className(this.rp.classification)}】 ${this.rp.site1 || ''} ${this.rp.site2 || ''}`
      },

      /**
       * コピペ
       * @param row 対象行
       * @param tar 対象曜日
       * @param isCopy コピーか否か
       */
      copyPaste(row, tar, isCopy) {
        const at = 'attendance' + tar
        const st = 'start' + tar
        const en = 'end' + tar
        const wh = 'workingHours' + tar

        // コピー
        if (isCopy) {
          this.copy = {
            at: row[at],
            st: row[st],
            en: row[en],
            wh: row[wh]
          }

        // ペースト
        } else {
          if (this.copy && Object.keys(this.copy).length) {
            row[at] = this.copy.at
            this.changeValue(row, at.replace('2', ''))
            row[st] = this.copy.st
            this.changeValue(row, st.replace('2', ''))
            row[en] = this.copy.en
            this.changeValue(row, en.replace('2', ''))
            row[wh] = this.copy.wh
            this.changeValue(row, wh.replace('2', ''))
          }
        }
      },

      /**
       * バリデーション
       */
      async validation() {
        // 入力必須確認
        for (let i = 0; i < require.length; i++) {
          let res
          const row = require[i]
          if (row == 'classification') {
            res = this.requireValidateArr(row)
          } else {
            res = this.requireValidateStr(row)
          }
          if (!res.result) {
            await dialogs.showErrorDialog('入力確認', res.message)
            return false
          }
        }

        // 物件名変更していないか
        const site = this.rp.buildingName
        if (!this.rp.siteCode) {
          await dialogs.showErrorDialog(site + 'の物件コード 取得失敗', '物件コードが取得できませんでした。再度、物件名をドロップダウンから選択してください。')
          return false
        }

        // 得意先変更ありの場合
        if (this.rp.classification[0] == '1') {
          if (this.rp.changeClient && !this.rp.clientName2) {
            await dialogs.showErrorDialog('変更後の得意先 未入力', '得意先変更ですが、変更後の得意先が未入力です。')
            return false
          }
          if (this.rp.changeClient && !this.rp.changeCdSite) {
            const log = await dialogs.showConfirmDialog('「物件コード変更」にチェックがついていません', '得意先変更ですが、「物件コード変更」なしでよろしいでしょうか？')
            if (log != 'YES') {
              return false
            }
          }
        }

        // ビルメンにチェックがある場合
        const isCheck = this.isCheckContractList()
        // ビルメンデータの作業内容区分コードが1000、2000の契約にチェックがついている場合
        const isCheck2 = this.isCheckContractList2()
        // 契約詳細情報にチェックのついた契約がある
        const isCheck3 = this.isCheckDetailList()
        // 契約詳細情報に変更箇所がある
        const isCheck4 = this.isCheckDetailList2()

        // ビルメンツデータがある場合
        if (this.rp.contractList && this.rp.contractList.length) {
          // チェックがない場合
          if (!isCheck) {
            const log = await dialogs.showConfirmDialog('ビルメンツの契約に1件もチェックなし', 'ビルメンツのデータに1件も' + this.className(this.rp.classification) + 'のチェックがついていませんが、よろしいでしょうか？')
            if (log != 'YES') {
              return false
            }
          // チェックあり
          } else {
            // ビルメンデータの作業内容区分コードが1000、2000の契約にチェックがついている場合、契約詳細情報にもついているか確認
            if (isCheck2 && this.rp.detailList && this.rp.detailList.length) {
              // 変更
              if (this.rp.classification[0] == '1') {
                if (!isCheck4) {
                  const log = await dialogs.showConfirmDialog('契約詳細情報に変更箇所なし', '契約詳細情報のデータに変更箇所がありませんが、よろしいでしょうか？')
                  if (log != 'YES') {
                    return false
                  }
                }
              // 退職
              } else if (this.rp.classification[0] == '2') {
                if (!isCheck3) {
                  const log = await dialogs.showConfirmDialog('契約詳細情報にチェックなし', '契約詳細情報のデータに1件も' + this.className(this.rp.classification) + 'のチェックがついていませんが、よろしいでしょうか？')
                  if (log != 'YES') {
                    return false
                  }
                }
              }
            }
          }
        }

        // 契約詳細情報の確認
        if (this.rp.classification[0] == '1' && isCheck4) {
          for (let i = 0; i < this.rp.detailList.length; i++) {
            const row = this.rp.detailList[i]

            // 実働時間と時間帯のチェック
            if (!await this.validateHours(row)) {
              return false
            }
          }
        }
        return true
      },

      /**
       * ビルメンツデータにチェックのついた契約がある
       */
      isCheckContractList() {
        if (this.rp.contractList && this.rp.contractList.length) {
          return this.rp.contractList.some((row) => row.check)
        }
        return false
      },

      /**
       * ビルメンデータの作業内容区分コードが1000、2000の契約にチェックがついている場合
       */
      isCheckContractList2() {
        if (this.rp.contractList && this.rp.contractList.length) {
          return this.rp.contractList.some((c) => (c.check && ['1000', '2000'].includes(c.cdKubunWorkContent)))
        }
        return false
      },

      /**
       * 契約詳細情報にチェックのついた契約がある
       */
      isCheckDetailList() {
        if (this.rp.detailList && this.rp.detailList.length) {
          return this.rp.detailList.some((row) => row.check)
        }
        return false
      },

      /**
       * 契約詳細情報に変更箇所がある
       */
      isCheckDetailList2() {
        if (this.rp.detailList && this.rp.detailList.length && this.rp.classification[0] == '1') {
          for (let i = 0; i < this.rp.detailList.length; i++) {
            const row = this.rp.detailList[i]
            for (let j = 0; j < Object.keys(row).length; j++) {
              const key = Object.keys(row)[j]
              // 変更ある
              if (key.indexOf('BgColor') > -1 && row[key]) {
                return true
              }
            }
          }
        }
        return false
      },

      /**
       * 実働時間と時間帯のチェック
       * @param row 対象行
       */
      async validateHours(row) {
        // 契約コード
        const target = '契約詳細情報【契約コード ' + row.cdContract + '】'
        for (let i = 0; i < this.weeks.length; i++) {
          const w = this.weeks[i]
          const wName = this.weekNames[i]

          // 実働時間
          const wh = 'workingHours' + w + '2'
          // 開始時間
          const st = 'start' + w + '2'
          // 終了時間
          const en = 'end' + w + '2'

          // 実働時間未入力は0を入れる
          if (!row[wh]) {
            row[wh] = '0'
            this.changeValue(row, wh)
          }

          if (row[st] == '0') {
            row[st] = ''
          }
          if (row[en] == '0') {
            row[en] = ''
          }

          // 時間帯が不正
          if ((row[st] && row[st].length > 0 && row[st].length < 4)) {
            await dialogs.showErrorDialog(`${target}の ${wName} 開始時間`, '値が不正です。\r\n「 ' + row[st] + ' 」となっています。')
            return false
          }

          // 時間帯が不正
          if ((row[en] && row[en].length > 0 && row[en].length < 4)) {
            await dialogs.showErrorDialog(`${target}の ${wName} 終了時間`, '値が不正です。\r\n「 ' + row[en] + ' 」となっています。')
            return false
          }

          // 時間帯チェック（いずれか未入力）
          if (!((row[st].length > 0 && row[en].length > 0)
            || (row[st].length == 0 && row[en].length == 0))) {
            await dialogs.showErrorDialog(`${target}の ${wName} 勤務時間帯`, '勤務時間が未完成です。')
            return false
          }

          // 時間範囲チェック（from to）
          if ((row[st].length > 0 && row[en].length > 0)
            && Number(row[st].replace(':', '')) >= Number(row[en].replace(':', ''))) {
            await dialogs.showErrorDialog(`${target}の ${wName} 勤務時間帯`, '開始と終了の時間が逆、もしくは同じです。\r\n勤務時間を正しく入力してください。')
            return false
          }

          // 実働時間 チェック
          if (row[st].length > 0 && Number(row[wh]) == 0) {
            await dialogs.showErrorDialog(`${target}の ${wName} 実働時間`, '開始・終了時間が入っていますが、実働時間が未入力です。')
            return false
          }

          // 勤務時間 チェック
          if (Number(row[wh]) > 0 && row[st].length == 0) {
            await dialogs.showErrorDialog(`${target}の ${wName} 勤務時間帯`, '実働時間が入っていますが、勤務時間（開始・終了）が未入力です。')
            return false
          }

          // 勤務時間と実働時間の関係
          const hours = Number(row[wh])
          if (hours > 0) {
            // 開始・終了時間から何時間になるかを取得
            const h = utils.getHours(row[st], row[en])
            // 実働時間の方が多い場合
            if (hours > h) {
              await dialogs.showErrorDialog(`${target}の ${wName} 実動時間が多い`, '開始～終了時間の拘束時間よりも実働時間が多くなっています。\r\n' + `${row[st]}～${row[en]}➡${h}時間拘束`)
              return false
            }
            // 6時間以上の場合、休憩時間を入れているか
            if (h >= 6) {
              if (h - hours < 0.75) {
                await dialogs.showErrorDialog(`${target}の ${wName} 実動時間`, '開始～終了時間で6時間以上拘束しています。\r\n45分以上の休憩を考慮し、実働時間を入力してください。\r\n（45分の休憩時間を考慮し、' + (h-0.75) + 'h 以下でないと登録できません。')
                return false
              }
            }
          }
        }
        return true
      },

      /**
       * 請求先マスタから情報取得
       */
      async getBillingData() {
        if (!this.rp.siteCode) {
          alert('物件コードなし')
          return
        }
        const res = await backend.searchData('akbsTable/getBillingData', { siteCode: this.rp.siteCode })
        if (res.data.data) {
          const data = res.data.data
          for (let i = 0; i < Object.keys(data).length; i++) {
            const key = Object.keys(data)[i]
            this.rp[key] = data[key]
          }
        }
        this.reload++
      },
    }
  }
</script>

<style scoped>
  table {
    background: white;
  }

  .bg-colu {
    background: #edecf7;
  }

  .bg-blue {
    background: rgb(243 247 249);
  }

  .i-bg-yellow-200 input,
  select.i-bg-yellow-200,
  .i-bg-yellow-200 >>> input[type=text],
  .i-bg-yellow-200 >>> input[type=text]:disabled {
    background-color: #FFF59D !important;
  }

  #client-name div input[type=text] {
    font-size: 13px !important;
  }

  .hr-week {
    background-color: lightgray;
    height: 1px;
    border: none;
    margin-top: 20px;
    margin-bottom: 10px;
  }
</style>